import { Component } from '@angular/core';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageKey, LocalStorageService } from '@auto-editor/data-access-local-storage';
import { UtilsService } from '@auto-editor/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

@Component({
  selector: 'auto-editor-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false
})
export class AppComponent {
  title = 'auto-editor';

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translateService: TranslateService,
    private localStorage: LocalStorageService,
    private router: Router,
    private utilsService: UtilsService
  ) {
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e) => {
      this.utilsService.hideSave.next(false);
    }); //mostrar el boton de guardar y Publicar questionnaire
    this.translateService.addLangs(['es', 'en', 'fr']);
    this.translateService.setDefaultLang('es');
    let lang = this.translateService.getBrowserLang();
    if (!['es', 'en', 'fr'].includes(lang)) lang = 'es';
    if (
      this.localStorage.getData(LocalStorageKey.languageSelected) === undefined ||
      this.localStorage.getData(LocalStorageKey.languageSelected) === ''
    ) {
      this.localStorage.saveData(LocalStorageKey.languageSelected, lang || 'es');
    }
    if (this.localStorage.getData(LocalStorageKey.languageSelected) && this.localStorage.getData(LocalStorageKey.languageSelected) !== '')
      this.translateService.use(this.localStorage.getData(LocalStorageKey.languageSelected));
    else this.translateService.use(lang || 'es');
    this.matIconRegistry.addSvgIconResolver((name: string, namespace: string): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
      switch (namespace) {
        case 'mat':
          return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/material-design-icons/outlined/${name}.svg`);
        case 'logo':
          return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/logos/${name}.svg`);
        case 'flag':
          return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/flags/${name}.svg`);
        default:
          return null;
      }
    });
  }
}
